import { Injectable } from '@angular/core';
import { CustomFileReader } from '../../models/intefaces/file-reader';

@Injectable({
  providedIn: 'root',
})
export class FileReaderService implements CustomFileReader {
  constructor() {}

  readFileAsArrayBuffer(file: Blob): Promise<ProgressEvent<FileReader>> {
    return new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = (fileProgress) => resolve(fileProgress);
      fileReader.readAsArrayBuffer(file);
    });
  }

  readFileAsBase64String(file: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
    });
  }


  // compressImage(image: any) {
  //   var orientation = -1;

  //   this.imageCompress.compressFile(image, orientation, 5, 5)
  //   .then(result => {
  //     alert(1)
  //     //imageFile created below is the new compressed file which can be send to API in form data
  //     const imageFile = new File([result], this.file?.name || "filename", { type: 'image/jpeg' });

  //     this.fileReady.emit(imageFile);
  //   })
  //   .catch(error => console.log({ error }))
  //   .finally(() => alert("ASdsads"));
  // }
}
